import React from 'react';
import { Provider } from 'react-redux';

import Widget from './components/Widget';
import store from './store';

const defaultProps = {
  title: 'Welcome',
  subtitle: 'This is your chat subtitle',
  senderPlaceHolder: 'Type a message...',
  showCloseButton: true,
  fullScreenMode: false,
  autofocus: true,
  chatId: 'rcw-chat-container',
  launcherOpenLabel: 'Open chat',
  launcherCloseLabel: 'Close chat',
  launcherOpenImg: '',
  launcherCloseImg: '',
  sendButtonAlt: 'Send',
  showTimeStamp: true,
  imagePreview: false,
  zoomStep: 80,
  showBadge: true
};

function ConnectedWidget({
  title = defaultProps.title,
  titleAvatar,
  subtitle = defaultProps.subtitle,
  senderPlaceHolder = defaultProps.senderPlaceHolder,
  showCloseButton = defaultProps.showCloseButton,
  fullScreenMode = defaultProps.fullScreenMode,
  autofocus = defaultProps.autofocus,
  profileAvatar,
  profileClientAvatar,
  launcher,
  config,
  handleNewUserMessage,
  handleQuickButtonClicked,
  handleTextInputChange,
  chatId = defaultProps.chatId,
  handleToggle,
  launcherOpenLabel = defaultProps.launcherOpenLabel,
  launcherCloseLabel = defaultProps.launcherCloseLabel,
  launcherCloseImg = defaultProps.launcherCloseImg,
  launcherOpenImg = defaultProps.launcherOpenImg,
  sendButtonAlt = defaultProps.sendButtonAlt,
  showTimeStamp = defaultProps.showTimeStamp,
  imagePreview = defaultProps.imagePreview,
  zoomStep = defaultProps.zoomStep,
  handleSubmit,
  showBadge = defaultProps.showBadge,
  resizable,
  emojis,
  showStartScreen,
  onSubmit,
  onFormSubmit
}) {
  return (
    <Provider store={store}>
      <Widget
        title={title}
        titleAvatar={titleAvatar}
        subtitle={subtitle}
        handleNewUserMessage={handleNewUserMessage}
        handleQuickButtonClicked={handleQuickButtonClicked}
        senderPlaceHolder={senderPlaceHolder}
        profileAvatar={profileAvatar}
        profileClientAvatar={profileClientAvatar}
        showCloseButton={showCloseButton}
        fullScreenMode={fullScreenMode}
        autofocus={autofocus}
        customLauncher={launcher}
        handleTextInputChange={handleTextInputChange}
        chatId={chatId}
        config={config}
        handleToggle={handleToggle}
        launcherOpenLabel={launcherOpenLabel}
        launcherCloseLabel={launcherCloseLabel}
        launcherCloseImg={launcherCloseImg}
        launcherOpenImg={launcherOpenImg}
        sendButtonAlt={sendButtonAlt}
        showTimeStamp={showTimeStamp}
        imagePreview={imagePreview}
        zoomStep={zoomStep}
        handleSubmit={handleSubmit}
        showBadge={showBadge}
        resizable={resizable}
        emojis={emojis}
        showStartScreen={showStartScreen}
        onSubmit={onSubmit}
        onFormSubmit={onFormSubmit}
      />
    </Provider>
  );
}

export default ConnectedWidget;
